import { GeneralItemRenderer } from "../GeneralItemRenderer";

/**
 * Jedná se o specializovaný renderer pro GridLayout jako item jiného GridLayoutu (nebere výšku z definice - výška se upraví podle vnitřních prvků)
 */
export class GridLayoutItemRenderer extends GeneralItemRenderer {
    public override get innerElementHeight(): number | string | undefined {
        return undefined;
    }
}
